var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message.bookingData
    ? _c(
        "div",
        { staticClass: "float-left ml-3 card-chat-booking" },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("b", [_vm._v(_vm._s(_vm.message.text))]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "mt-2" },
                [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("label", { staticClass: "col-4" }, [_vm._v("บริการ:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8" }, [
                      _vm.message.bookingData.service.id === 1 ||
                      _vm.hasServiceItems
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("multiLangName")(
                                    _vm.message.bookingData.service
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("multiLangName")(
                                    _vm.globalState.services[
                                      _vm.message.bookingData.service.parent_id
                                    ]
                                  )
                                )
                            ),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.message.bookingData.service
                                )
                              ) + "\n          "
                            )
                          ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.message.bookingData.service.id != 1 &&
                  _vm.message.bookingData.service_items
                    ? _c("div", { staticClass: "row no-gutters" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v("รายการ:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-8" },
                          _vm._l(
                            _vm.message.bookingData.service_items,
                            function(serviceItem) {
                              return _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getServiceItemName(serviceItem.id)
                                    ) +
                                    ": " +
                                    _vm._s(serviceItem.quantity) +
                                    " " +
                                    _vm._s(
                                      _vm.getServiceItemUnit(serviceItem.id)
                                    ) +
                                    "\n            "
                                )
                              ])
                            }
                          ),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row no-gutters mt-2" }, [
                    _c("label", { staticClass: "col-4" }, [
                      _vm._v("วันที่รับบริการ:")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8" }, [
                      _vm.preBookingData && _vm.preBookingData.package_type
                        ? _c("div", [
                            _c("span", { staticClass: "text-orange" }, [
                              _c("i", { staticClass: "fal fa-layer-group" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("message.my_reservations.package")
                                  ) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                " - " +
                                  _vm._s(
                                    _vm._f("multiLangName")(
                                      _vm.preBookingData.package_type
                                    )
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.preBookingData.package_type.category ===
                            "flexible"
                              ? _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.new_booking.package_count",
                                          {
                                            count:
                                              _vm.preBookingData
                                                .package_type_discount
                                                .booking_qty
                                          }
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm.preBookingData.package_type.category ===
                                "unlimited"
                              ? _c("div", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.new_booking.package_count",
                                          {
                                            count:
                                              _vm.preBookingData
                                                .multi_dates_times.length
                                          }
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                  _c(
                                    "section",
                                    { staticClass: "mt-2 pb-0 mb-0" },
                                    [
                                      _c(
                                        "ul",
                                        { staticClass: "ml-4 pb-0 mb-0" },
                                        _vm._l(
                                          _vm.preBookingData.multi_dates_times,
                                          function(selectedDateTime) {
                                            return _c(
                                              "li",
                                              {
                                                staticClass: "text-order-title"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("shortDate")(
                                                        selectedDateTime
                                                      )
                                                    ) +
                                                    " • " +
                                                    _vm._s(
                                                      _vm._f("onlyTime")(
                                                        selectedDateTime
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _c("div", [
                            Number(
                              _vm.message.bookingData.is_no_datetime_booking
                            ) === 0
                              ? _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm._f("prettyDate")(
                                          _vm.message.bookingData.cleaning_date
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _c("span", { staticClass: "text-orange" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.new_booking.booking_type_flexible"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                          ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.message.bookingData.service.id === 1
                    ? _c("div", { staticClass: "row no-gutters mt-2" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v("ระยะเวลา:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.message.bookingData.work_hour) +
                              " " +
                              _vm._s(
                                _vm.$tc(
                                  "message.hour",
                                  Number(_vm.message.bookingData.work_hour)
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.message.bookingData.professional
                    ? _c("div", { staticClass: "row no-gutters mt-2" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v("ผู้ให้บริการ:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8" }, [
                          _c("img", {
                            staticClass: "rounded-circle mr-2",
                            attrs: {
                              src:
                                _vm.message.bookingData.professional
                                  .full_picture,
                              alt: "",
                              width: "40"
                            }
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("firstName")(
                                  _vm.message.bookingData.professional.full_name
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row no-gutters mt-2" }, [
                    _c("label", { staticClass: "col-4" }, [_vm._v("ที่อยู่:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8" }, [
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.message.bookingData.user_place.place_name)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.message.bookingData.user_place.address)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.message.bookingData.user_place.district
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.message.bookingData.user_place.district
                                )
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.message.bookingData.user_place.address_province
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.message.bookingData.user_place
                                    .address_province
                                )
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.message.bookingData.user_place.user_place_pet_types.length
                    ? _c("div", { staticClass: "row no-gutters mt-2" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v("สัตว์เลี้ยง:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getPetTypesResult()) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.message.bookingData.remark
                    ? _c("div", { staticClass: "row no-gutters mt-2" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v("หมายเหตุ:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.message.bookingData.remark) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    !_vm.hasLocation
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex border border-warning justify-content-start align-items-top -bg-warning-soft rounded-all p-2 my-2 text-small"
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "pl-2" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.contact_step.no_location_warning"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.booking.contact_step.location")
                          ) + ":"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card my-0 border-divider text-small" },
                        [
                          _c("div", { staticClass: "card-body p-2" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-start align-items-center"
                              },
                              [
                                _c("div", { staticClass: "flex-fill" }, [
                                  _vm.hasLocation
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "fal fa-check-circle text-success fa-lg"
                                        }),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.contact_step.pinned_location"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "fal fa-exclamation-circle text-danger fa-lg"
                                        }),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.contact_step.unpinned_location"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-info",
                                      on: {
                                        click: function($event) {
                                          return _vm.openPinlocationModal()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.hasLocation
                                              ? _vm.$t("message.button.edit")
                                              : _vm.$t("message.button.add")
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.customerPhotoUrls
                    ? _c("div", { staticClass: "row no-gutters mt-2" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.booking.checkout_step.customer_area_photos"
                                )
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-8" },
                          [
                            _c(
                              "b-carousel",
                              {
                                staticStyle: {
                                  "text-shadow": "1px 1px 2px #333"
                                },
                                attrs: {
                                  id: "carousel-1",
                                  interval: 0,
                                  controls: "",
                                  indicators: "",
                                  background: "#ababab",
                                  "img-height": "150"
                                },
                                on: {
                                  "sliding-start": _vm.onSlideStart,
                                  "sliding-end": _vm.onSlideEnd
                                },
                                model: {
                                  value: _vm.slide,
                                  callback: function($$v) {
                                    _vm.slide = $$v
                                  },
                                  expression: "slide"
                                }
                              },
                              _vm._l(_vm.customerPhotoUrls, function(imageUrl) {
                                return _c("b-carousel-slide", {
                                  attrs: { "img-src": imageUrl }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("checkout-cost", {
                    on: { onChangedCostData: _vm.updateCostData }
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.isExpired
                    ? _c("div", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-info btn-block",
                            on: {
                              click: function($event) {
                                return _vm.newBooking()
                              }
                            }
                          },
                          [_vm._v("ทำการจองใหม่")]
                        )
                      ])
                    : _c("div", [
                        _vm.hasServiceItems
                          ? _c("div", { staticClass: "card" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "card-body text-info text-small"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.service_item.checkout_remark"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("label", { staticClass: "mb-0" }, [
                          _vm._v("กรุณายอมรับเงื่อนไขการให้บริการก่อนชำระเงิน")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-3 custom-control custom-checkbox text-small"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.acceptTerms,
                                  expression: "acceptTerms"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: {
                                id: "acceptTerms_" + _vm.randomInitKeyInput,
                                type: "checkbox",
                                name: "acceptTerms_" + _vm.randomInitKeyInput
                              },
                              domProps: {
                                checked: Array.isArray(_vm.acceptTerms)
                                  ? _vm._i(_vm.acceptTerms, null) > -1
                                  : _vm.acceptTerms
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.acceptTerms,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.acceptTerms = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.acceptTerms = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.acceptTerms = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: {
                                  for: "acceptTerms_" + _vm.randomInitKeyInput
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.accept_conditions01"
                                      )
                                    ) +
                                    "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.accept_conditions02"
                                      )
                                    ) +
                                    "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.accept_conditions03"
                                      )
                                    ) +
                                    "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.accept_conditions05"
                                      )
                                    ) +
                                    "\n              "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "/term", target: "_blank" }
                                  },
                                  [
                                    _c("u", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.checkout_step.learn_more"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.acceptTerms && !_vm.hasLocation
                ? _c("div", { staticClass: "text-danger text-center pt-4" }, [
                    _c("i", { staticClass: "fas fa-exclamation-circle" }),
                    _vm._v(
                      " กรุณาระบุตำแหน่งที่พักก่อนดำเนินการชำระเงิน\n      "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.acceptTerms && _vm.hasLocation,
                  expression: "acceptTerms && hasLocation"
                }
              ]
            },
            [
              !_vm.isExpired
                ? _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _vm.totalPrice > 20
                        ? _c(
                            "div",
                            { staticClass: "pb-3" },
                            [
                              !_vm.qrPaymentSuccess
                                ? _c("payment-methods", {
                                    ref: "paymentMethods",
                                    on: {
                                      onSelectedPaymentMethod:
                                        _vm.updatePaymentMethod,
                                      onSelectedCreditCard:
                                        _vm.applyUserCreditCard,
                                      onRequestedSavingTempData:
                                        _vm.saveTempData,
                                      onSelectedFileUpload: _vm.setFileUpload,
                                      onSuccessQrPayment:
                                        _vm.displaySuccessDialog
                                    }
                                  })
                                : _c("div", { staticClass: "text-center" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-check-circle -status-accepted"
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("message.success")) +
                                        "\n          "
                                    )
                                  ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _vm.displayPaymentButton
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-block",
                                attrs: { disabled: _vm.isLoading },
                                on: {
                                  click: function($event) {
                                    return _vm.submitFormData()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isLoading
                                      ? "กำลังโหลด..."
                                      : "ยืนยันการจอง"
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayContactAdmin
                          ? _c("div", [
                              _c("div", { staticClass: "text-remark pb-3" }, [
                                _c("i", {
                                  staticClass:
                                    "fas fa-exclamation-triangle text-orange"
                                }),
                                _vm._v(
                                  "\n              เวลาที่คุณต้องการใช้บริการค่อนข้างกระชั้น กรุณาติดต่อแอดมินเพื่อช่วยประสานงานหาผู้ให้บริการที่สะดวกรับงานในเวลาที่คุณต้องการ\n              "
                                ),
                                _vm.message.type !==
                                "booking-summary-incomplete"
                                  ? _c("span", [
                                      _vm._v("หรือเปลี่ยนวันและเวลาใหม่")
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-info btn-block",
                                  attrs: {
                                    href: "https://line.me/R/ti/p/%40hnk7011n",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("ติดต่อแอดมิน")]
                              ),
                              _vm._v(" "),
                              _vm.message.type !== "booking-summary-incomplete"
                                ? _c("div", { staticClass: "pt-3" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-info btn-block",
                                        on: { click: _vm.changeDateTime }
                                      },
                                      [_vm._v("เปลี่ยนวันและเวลาใหม่")]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.message.type === "booking-summary-incomplete"
                          ? _c("div", { staticClass: "mt-2" }, [
                              _vm.displayPaymentButton
                                ? _c("div", [
                                    _c("hr"),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-info btn-block",
                                        on: {
                                          click: function($event) {
                                            return _vm.newBooking()
                                          }
                                        }
                                      },
                                      [_vm._v("ทำการจองใหม่")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-info btn-block",
                                        on: {
                                          click: function($event) {
                                            return _vm.cancelBooking()
                                          }
                                        }
                                      },
                                      [_vm._v("ยกเลิก")]
                                    )
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "text-center p-2" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-check-circle -status-accepted"
                                      }),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("message.success")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("snackbar", {
            ref: "snackbar",
            attrs: {
              baseSize: "100px",
              colors: {
                open: "#333",
                info: "#3DBD7D",
                error: "#FA7377",
                warn: "#FF6600"
              },
              holdTime: 2500,
              position: "bottom-center"
            }
          }),
          _vm._v(" "),
          _c("pin-location-modal", {
            ref: "pinLocationModal",
            attrs: { settings: _vm.settings },
            on: { savedLocation: _vm.setLocation }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-exclamation-circle text-danger fa-lg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pb-3 text-small" }, [
      _c("i", { staticClass: "fa fa-exclamation-triangle -status-alert" }),
      _vm._v(
        "\n            ไม่สามารถดำเนินการชำระเงินได้ เนื่องจากเวลาที่คุณต้องการใช้บริการค่อนข้างกระชั้น กรุณาทำรายการจองใหม่\n          "
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69ac8adf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ac8adf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/BookingSummaryMessage.vue
// module id = 2217
// module chunks = 0